import React, { useState, useMemo, useCallback } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TouchableIcon } from '@components/common/Touchable';
import styles from './MenuCartSeat.module.scss';
import { LABEL, CUSTOM_MESSAGES } from '@veriables';
import CheckNameEditModal from './Modals/CheckNameEditModal';
import OfferModal from './Modals/OfferModal';
import OrderLoyalty from '@components/LoyaltyInOrder';
import { setOrderLoyaltyType } from '@reducers/loyalty';
import { setErrorPopUp } from '@reducers/notification';
import { safeJsonParse } from '@utility/helperFunction';

const MenuCartSeat = ({ position, serverAppTheme, seat, cart, setOrderLoyaltyType, setErrorPopUp }) => {
  const [isCheckNameEditModalOpen, setIsCheckNameEditModalOpen] = useState(false);
  const [isLoyaltyInfoOpen, setIsLoyaltyInfoOpen] = useState(false);
  const [isOfferModalOpen, setIsOfferModalOpen] = useState(false);

  const showLoyaltyIcon = useMemo(() => {
    try {
      const auth = safeJsonParse(sessionStorage.getItem('auth'), {});
      return !!auth?.loyaltyInfo?.supportsLoyalty;
    } catch (e) {
      return false;
    }
  }, []);

  const seats = seat?.seats || [];
  const currentSeat = useMemo(
    () => seats.find(s => s.id === position.id) || null,
    [seats, position.id]
  );

  const handleOfferModalClose = useCallback(() => {
    setIsOfferModalOpen(false);
  }, []);

  const handleLoyaltyIconClick = useCallback(
    e => {
      e.preventDefault();
      e.stopPropagation();
      if (cart?.length > 0) {
        setErrorPopUp({
          res: CUSTOM_MESSAGES().OLS_ORDERS_LOYALTY_ERROR,
          noErrorTxt: true,
        });
        return;
      }
      if (currentSeat && currentSeat.offer !== null) {
        setIsOfferModalOpen(true);
      } else {
        setIsLoyaltyInfoOpen(true);
        setOrderLoyaltyType(1);
      }
    },
    [cart, currentSeat, setErrorPopUp, setOrderLoyaltyType]
  );

  return (
    <div className="h-8 w-100 mt-2">
      <div
        className="row mx-0 w-100 d-flex align-items-center justify-content-between mb-2"
        style={{
          borderRadius: '4px',
          border: '1px solid #79747E',
          height: '32px',
          color: serverAppTheme?.primary_text,
          padding: '0 8px',
        }}
      >
        <div className="col-10 d-flex align-items-center px-0 mt-1">
          <div
            className={cn(
              Number(position?.number) === -1
                ? 'fw-600 text-center'
                : 'fw-500 fs_16',
              styles.truncate,
              'd-flex align-items-center'
            )}
          >
            {position?.name !== null && position?.name?.length > 0 ? (
              <>
                <span>{position?.name?.slice(0, 4).concat('..')}</span>
                {Number(position?.number) !== -1 && (
                  <span>&nbsp;({`Seat ${position?.number}`})</span>
                )}
              </>
            ) : Number(position?.number) === -1 ? (
              LABEL().TABLE
            ) : (
              <span>{`Seat ${position?.number}`}</span>
            )}
            {Number(position?.number) !== -1 && (
              <div
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  setIsCheckNameEditModalOpen(true);
                }}
                className="ml-2"
                style={{
                  position: 'relative',
                  zIndex: 1,
                }}
              >
                <TouchableIcon
                  className="fas fa-edit"
                  aria-hidden="true"
                  style={{ width: '18px', height: '18px', fontSize: '18px' }}
                />
              </div>
            )}
          </div>
        </div>

        {Number(position?.number) !== -1 && showLoyaltyIcon && (
          <div className="col-2 d-flex justify-content-end align-items-center px-0">
            <div
              onClick={handleLoyaltyIconClick}
              style={{
                display: 'inline-block',
                cursor: 'pointer',
                padding: '3px 5px',
                borderRadius: '4px',
                position: 'relative',
                zIndex: 1,
              }}
            >
              {currentSeat?.offer !== null && (
                <svg
                  width="20"
                  height="19"
                  viewBox="0 0 20 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 15.27L16.18 19L14.54 11.97L20 7.24L12.81 6.63L10 0L7.19 6.63L0 7.24L5.46 11.97L3.82 19L10 15.27Z"
                    fill="#2541A4"
                  />
                </svg>
              )}

              {currentSeat?.offer === null && currentSeat?.loyalty !== null && (
                <svg
                  width="20"
                  height="19"
                  viewBox="0 0 20 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 15.27L16.18 19L14.54 11.97L20 7.24L12.81 6.63L10 0L7.19 6.63L0 7.24L5.46 11.97L3.82 19L10 15.27Z"
                    fill="#74A4FF"
                  />
                </svg>
              )}

              {currentSeat?.offer === null && currentSeat?.loyalty === null && (
                <svg
                  width="20"
                  height="19"
                  viewBox="0 0 20 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 15.27L16.18 19L14.54 11.97L20 7.24L12.81 6.63L10 0L7.19 6.63L0 7.24L5.46 11.97L3.82 19L10 15.27Z"
                    fill="#7D7D7D"
                  />
                </svg>
              )}
            </div>
          </div>
        )}
      </div>

      {isCheckNameEditModalOpen && (
        <CheckNameEditModal
          isOpen={isCheckNameEditModalOpen}
          closeModal={() => setIsCheckNameEditModalOpen(false)}
        />
      )}

      {isOfferModalOpen && (
        <OfferModal
          isOpen={isOfferModalOpen}
          handleOfferModalClose={handleOfferModalClose}
        />
      )}

      {isLoyaltyInfoOpen && (
        <OrderLoyalty
          isOpen={isLoyaltyInfoOpen}
          onClose={() => setIsLoyaltyInfoOpen(false)}
          check={seat}
          currentSeat={currentSeat}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({ orders, theme }) => ({
  position: orders.position,
  serverAppTheme: theme.serverAppTheme,
  seat: orders.seats,
  cart: orders.cart,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setOrderLoyaltyType,
      setErrorPopUp,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(MenuCartSeat));
